import axios from "axios";
import { UntypedExperiment, CorpBusinessExperimentsMap } from "../../types";
import { config } from "../config";

const END_POINT = `/api/v0/experiments/cotb/active`;

const createCorpBusinessExperimentsMap = (
  experiments: UntypedExperiment[]
): CorpBusinessExperimentsMap => {
  const CorpBusinessExperimentsMap = experiments.reduce((acc, experiment) => {
    acc[experiment.id] = experiment;

    return acc;
  }, {} as Partial<CorpBusinessExperimentsMap>) as CorpBusinessExperimentsMap;

  return CorpBusinessExperimentsMap;
};

export const fetchActiveBusinessExperiments = async () => {
  const { data } = await axios.put(END_POINT, {}, { baseURL: config.baseURL });

  return {
    experiments: createCorpBusinessExperimentsMap(data.experiments),
    trackingProperties: data.trackingProperties,
  };
};

export { fetchCorporateExperimentsByBusiness } from "./fetchCorporateExperimentsByBusiness";
